import React from 'react';

export const Alerts = (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="37"
        height="38"
        viewBox="0 0 37 38"
    >
        <g fill="none" fillRule="evenodd">
            <path
                stroke="#2A4473"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth=".8"
                d="M24.999 25.055l1.286 7.292a1.9 1.9 0 0 1-1.54 2.201l-15.97 2.816a1.9 1.9 0 0 1-2.2-1.541L1.33 6.08a1.899 1.899 0 0 1 1.54-2.2l15.97-2.815a1.899 1.899 0 0 1 2.2 1.54l1.29 7.318"
            />
            <path
                stroke="#2A4473"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth=".8"
                d="M22.775 24.262l.806 4.57-15.668 2.763L3.683 7.61l15.668-2.763.835 4.732M9.79 4.679l2.82-.497M17.48 32.933a1.235 1.235 0 1 1-2.433.43 1.235 1.235 0 0 1 2.434-.43z"
            />
            <path
                stroke="#2A4473"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth=".8"
                d="M24.432 11.61c2.41-6.123 10.48-3.722 10.151 2.792-.321 6.375-7.716 11.02-7.716 11.02s-8.537-1.836-11.02-7.716c-2.537-6.01 4.226-11.025 8.585-6.096z"
            />
            <path
                stroke="#2A4473"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth=".8"
                d="M24.999 25.055l1.286 7.292a1.9 1.9 0 0 1-1.54 2.201l-15.97 2.816a1.9 1.9 0 0 1-2.2-1.541L1.33 6.08a1.899 1.899 0 0 1 1.54-2.2l15.97-2.815a1.899 1.899 0 0 1 2.2 1.54l1.29 7.318"
            />
            <path
                stroke="#2A4473"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth=".8"
                d="M22.775 24.262l.806 4.57-15.668 2.763L3.683 7.61l15.668-2.763.835 4.732M9.79 4.679l2.82-.497M17.48 32.933a1.235 1.235 0 1 1-2.433.43 1.235 1.235 0 0 1 2.434-.43z"
            />
            <path
                fill="#EAC9EF"
                d="M21.897 10.924c-2.346.302-4.725 2.539-3.368 6.434.905 2.596 4.822 5.37 11.751 8.322 4.42-4.43 6.666-7.998 6.739-10.705.109-4.06-1.692-6.31-4.85-6.08-2.104.154-3.837 1.773-5.198 4.858-1.818-2.088-3.51-3.031-5.074-2.83z"
            />
            <path
                stroke="#2A4473"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.02"
                d="M24.432 11.61c2.41-6.123 10.48-3.722 10.151 2.792-.321 6.375-7.716 11.02-7.716 11.02s-8.537-1.836-11.02-7.716c-2.537-6.01 4.226-11.025 8.585-6.096z"
            />
            <path
                fill="#DFE5F2"
                d="M4.767 9.056l4.06 21.857 14.302-2.599c-5.774-2.345-9.452-4.246-11.036-5.702-1.583-1.455-4.025-5.974-7.326-13.556z"
            />
        </g>
    </svg>
);
